///<reference path='../config.ts' />
"use strict"

module agi.expressions.card.manifest {

    export interface ObjectConfig{
        name:string,
        type:ObjectType
        x:number,
        y:number
    };

    export interface LevelConfig{
        index: number; //needed to sort level configs as they come in asynchronously
        objectConfigs: Array<ObjectConfig>;
    }

    //Enumeration of object types
    export enum ObjectType{
         HiddenObject,
         props,
         foreground
    };

    export class AssetManifest {
        public sheetUrls:Array<string>;
        public audioUrls:Array<Array<string>>; 
        public groupUrls:Array<string>;
        public extrasUrl : string;
        public desktopMenuUrls:any;
        public closeButtonUrl:string;
        public endScreenUrl:string; 
        public loaderGIF:string;
        public sfxData:IHowlProperties;
        public musicData:IHowlProperties;
        public playButtonURLs:{receiver:string, sender:string, end:string}
        public menuAssets:any;
        public fountain:Array<Array<PIXI.Point>>;
        //List of object configurations 
        public levelConfigurations : Array<LevelConfig>;
        //List of base urls where object csv files are located
        public levelConfigUrls : Array<string>;
        //File extensions for object images
        public objectFileExt = ".png";
        public uiMenubarAssets:Array<string>;
        public fireEmitter:any;
        public isReady : boolean = false;
        public onready : () => void;

        constructor (assetPath:string){

            this.sheetUrls  = [
                assetPath + 'images/sprites0.json',
                assetPath + 'images/sprites1.json',
                assetPath + 'images/sprites2.json'
            ];
            this.audioUrls = [[               
                assetPath + "audio/music.m4a",
                assetPath + "audio/music.mp3",
                assetPath + "audio/music.ogg",
                assetPath + "audio/music.ac3"
                ],
                [
                assetPath + "audio/sfx.m4a",
                assetPath + "audio/sfx.mp3",
                assetPath + "audio/sfx.ogg",
                assetPath + "audio/sfx.ac3"
            ]];
            
            this.desktopMenuUrls  = {
                frame: assetPath + 'images/desktopframe.png',
                closeButton: assetPath + 'images/closebutton.png',
                replayButton: assetPath + 'images/replaybutton.png',
                audioOnButton: assetPath + 'images/audioonbutton.png',
                audioOffButton: assetPath + 'images/audiooffbutton.png',
                sendButton: assetPath + 'images/sendbutton.png'
            };

            // this.sfxData = {
            //     src : this.audioUrls[1],
            //     sprite: {
            //         "sfx1": [
            //         0,
            //         6537.505668934241
            //         ],
            //         "sfx2": [
            //         8000,
            //         2159.455782312925
            //         ]
            //     }
            // };
            this.sfxData = {
                "src": this.audioUrls[1],
                "sprite": {
                    "Finding_Game_SFX_Short": [
                        0,
                        2709.6598639455783
                      ],
                      "Finding_Game_V3_Ending": [
                        4000,
                        13000
                      ]
                  }
              }

            this.musicData = {
                src : this.audioUrls[0],
                loop: true,
                "sprite": {
                    "01_Finding_Game_V2_Opening_Loop_V3": [
                        0,
                        10978.684807256237
                      ],
                      "02_Finding_Game_In_Game_Loop_V3": [
                        13000,
                        50000
                      ]
                }
            };

            this.playButtonURLs = {
                sender: assetPath + 'images/play.png',
                receiver: assetPath + 'images/play.png',
                end: assetPath + 'images/end.png'
            }

            this.menuAssets = {
                replayButton: 'Menu/menu_startover.png',
                openButton: 'Menu/menu_menu.png',
                closeButton: 'Menu/menu_close.png',
                fullscreenCloseButton: 'Menu/menu_exit.png',
                muteSoundButton: 'Menu/menu_mute.png',
                unMuteSoundButton: 'Menu/menu_unmute.png',
                sendButton: 'Menu/menu_send.png',
            }

            //Sprites that might be messed up
            //bow or pink-bow 
            //gold watch
            //microphone
            //silver-watch (typo on json file) I renamed the object sprites


            //Purposefully exclude assetPath here, as TextureCache does not use absolute paths!
            this.groupUrls = [
                "objects/group_one/",
                "objects/group_two/"
            ];

            this.levelConfigUrls = [
                assetPath + "data/group_one_all.json",
                assetPath + "data/group_two_all.json"
            ];


            
            this.uiMenubarAssets = [
                "UI/menubar_1.png",
                "UI/menubar_2.png"
            ];

            this.fountain = [
                [new PIXI.Point(1166,542),new PIXI.Point(1,0.5)],
                [new PIXI.Point(1275,542), new PIXI.Point(1,0.5)],
                [new PIXI.Point(1107,662),new PIXI.Point(1,0.75)],
                [new PIXI.Point(1332,662),new PIXI.Point(1,0.75)],
                [new PIXI.Point(1026,905),new PIXI.Point(1,1)],
                [new PIXI.Point(1412,905),new PIXI.Point(1,1)],
                [new PIXI.Point(1192,652),new PIXI.Point(1,1)],
                [new PIXI.Point(1262,652),new PIXI.Point(1,1)],
                [new PIXI.Point(1200,430),new PIXI.Point(1.5,0.45)]
            ];

            this.closeButtonUrl = assetPath + 'images/end.png';
            this.loaderGIF = assetPath + 'images/bma.gif';

            this.fireEmitter = {
                "alpha": {
                    "start": 1,
                    "end": 0.76
                },
                "scale": {
                    "start": 0.2,
                    "end": 0.1,
                    "minimumScaleMultiplier": 1
                },
                "color": {
                    "start": "#fcf8bd",
                    "end": "#fc561f"
                },
                "speed": {
                    "start": 5,
                    "end": 10,
                    "minimumSpeedMultiplier": 0.5
                },
                "acceleration": {
                    "x": 0,
                    "y": 0
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 267,
                    "max": 273
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": 0,
                    "max": 0
                },
                "lifetime": {
                    "min": 1.8,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 50,
                "pos": {
                    "x": 0,
                    "y": 0
                },
                "addAtBack": false,
                "spawnType": "point"
            }
            this.fetchExternalData(assetPath);
        }

        /**
         * Fetch all the external json data and fill the apppropriate member variables with said fields
         */
        private fetchExternalData(assetPath: string){

            this.extrasUrl = assetPath + "data/extra.json";

            //Start off by fetching preliminary data, and we can do this asynchronously
            let preliminaryRequestCount = 1;
            let preliminarySuccessfulRequests = 0;

            let extrasInfo : {[x:string]: {type:string, opti?:number}};
            let defaultType : ObjectType = 0;
            let typeReq = new XMLHttpRequest();
            //First, fetch the type data
            typeReq.onload = e => {
                extrasInfo = <{[x:string]:any}>JSON.parse(typeReq.responseText);
                preliminaryRequestComplete();
            };
            typeReq.open("GET", this.extrasUrl);
            typeReq.send();

            let preliminaryRequestComplete = () => {
                preliminarySuccessfulRequests++;
                //If this is true, we've got all the preliminary data and can fetch object data
                if (preliminarySuccessfulRequests >= preliminaryRequestCount){

                    this.levelConfigurations = [];
                    let successfulRequests = 0;
                    //Now load in each level configuration
                    for (let i=0; i<this.levelConfigUrls.length; i++){
                        let levelConfigUrl = this.levelConfigUrls[i];
                        let objDataReq = new XMLHttpRequest();
                        objDataReq.onload = e => {
                            let jsonData = JSON.parse(objDataReq.responseText); //We'll get an object without the type, make a new object with the type info
                            let levelConfig : LevelConfig = {
                                index: i,
                                objectConfigs: []
                            }
                            for (let i=jsonData.length-1; i>=0; i--){ //Read in backwards to to match Photoshop layer system (stack)
                                let objData = jsonData[i];
                                let objExtraInfo = extrasInfo[objData.name];
                                let objConfig : ObjectConfig = {
                                    name: objData.name,
                                    type: objExtraInfo ? ObjectType[objExtraInfo.type] : ObjectType.HiddenObject,
                                    x: objData.x,
                                    y: objData.y
                                };
                                levelConfig.objectConfigs.push(objConfig);
                            };
                            this.levelConfigurations.push(levelConfig);
                            successfulRequests++;
                            //Check if we're done after each request, as they are asynchronous
                            if (successfulRequests == this.levelConfigUrls.length)
                            {
                                //Sort the level configs in case they were recieved in the wrong order
                                this.levelConfigurations.sort( (a,b) => a.index - b.index );
                                this.isReady = true;
                                if (this.onready)
                                    this.onready();
                            }
                        };
                        objDataReq.open("GET", levelConfigUrl);
                        objDataReq.send();
                    }
                }
            }
        }
    }
}